import { render, staticRenderFns } from "./bottomCom.vue?vue&type=template&id=9465b438&scoped=true"
import script from "./bottomCom.vue?vue&type=script&lang=js"
export * from "./bottomCom.vue?vue&type=script&lang=js"
import style0 from "./bottomCom.vue?vue&type=style&index=0&id=9465b438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9465b438",
  null
  
)

export default component.exports